/* "Barrel" of Http Interceptors */
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { Injectable } from '@angular/core';

import {
  ErrorHandlingService,
  GLOBAL_API_DEFAULT_TIMEOUT,
  GlobalHttpErrorInterceptor,
  GlobalHttpTimeoutInterceptor,
  RequestsCacheBustingInterceptor,
} from '@clickd-angular/common-lib';
import { Observable } from 'rxjs';
import { AddCommonQueryStringParamsToMscrmappApisInterceptor } from './add-common-query-string-interceptor';
@Injectable()
export class HttpWithCredentialsRequestsInterceptorV2
  implements HttpInterceptor
{
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.url.indexOf('email-account-api') === -1) {
      req = req.clone({
        withCredentials: true,
      });
    }

    return next.handle(req);
  }
}

/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: RequestsCacheBustingInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: GlobalHttpErrorInterceptor,
    multi: true,
    deps: [ErrorHandlingService],
  },
  { provide: GLOBAL_API_DEFAULT_TIMEOUT, useValue: 120000 },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: GlobalHttpTimeoutInterceptor,
    multi: true,
    deps: [GLOBAL_API_DEFAULT_TIMEOUT],
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: HttpWithCredentialsRequestsInterceptorV2,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AddCommonQueryStringParamsToMscrmappApisInterceptor,
    multi: true,
  },
];
